import { useEffect } from 'react'
import { useTheme } from '@emotion/react'

type PollOptions = {
  page: string
  maxNumber: number
  probability?: number
}

const PROBABILITY = 0.25

// Pop-up polls.
export default function useRandomPoll({ page, maxNumber, probability = PROBABILITY }: PollOptions) {
  const { brand } = useTheme()
  const randomPollNumber = Math.floor(Math.random() * maxNumber + 1)
  const trigger = `${page}-${randomPollNumber}-${brand}`

  useEffect(() => {
    if (Math.random() > probability || typeof window.hj !== 'function') return

    const timeoutId = setTimeout(() => window.hj!('trigger', trigger), 500)

    return () => clearTimeout(timeoutId)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  // Deps shouldn't change at runtime, we only run this hook once.

  // For tests.
  return randomPollNumber
}
